module.exports = __webpack_public_path__ + "img/igtech.605a406f.svg";